import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import has from 'lodash/has'
import clone from 'lodash/clone'
import get from 'lodash/get'
import isObject from 'lodash/isObject'
import isNil from 'lodash/isNil'

import Phone from 'components/shared/Phone'
import { SHOPIFY_GRAY, fontSize } from 'components/styles'
import { applyCustomFields } from 'controllers/logic'
import { changeEditorScene } from 'actions/locationAC'
import { publishAndActivate, gotoDashboard } from 'controllers/shopifyApp'
import { getTemplateByApp, getTemplateInfo } from 'templates/templates'
import ShopifyWizardIllustration from './shopifyWizard/ShopifyWizardIllustration'
import ShopifyAppEditor from './shopifyWizard/ShopifyAppEditor'
import ShopifyOverlay from './shopifyWizard/ShopifyOverlay'
import ShopifyWizardFinalScene from './shopifyWizard/ShopifyWizardFinalScene'
import ShopifyIAEditorLayer from './shopifyWizard/ShopifyIAEditorLayer'
import ProductsSlideWizard from './shopifyWizard/ProductsSlideWizard'
import AddCollection from './shopifyWizard/AddCollection'
import * as shopifyAppSceneId from 'constants/shopifyAppSceneId'
import * as scenes from 'templates/outSide/scenes'
import { setShopifyBarTitle } from 'controllers/shopifyBar'
import { trackEvent } from 'utils/utils'

const DEFAULT_MODE = 'DEFAULT_MODE'
const PRODUCTS_SLIDE_WIZARD = 'PRODUCTS_SLIDE_WIZARD'
const ADD_COLLECTION = 'ADD_COLLECTION'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${SHOPIFY_GRAY};
  display: flex;
  align-items: center;
  ${fontSize}
  line-height: 1
`
const PhoneContainer = styled.div`
  position: relative;
  flex: 1;
  height: 100%;
  display: flex;
`
const CenteredLayer = styled.div`
  position: absolute;
  top: 0;
  right: 10%;
  height: 80%;
  margin-top: 2em;
`
const EditorContainer = styled.div`
  flex: 1.5;
  height: 100%;
`
const OverlayContainer = styled.div`
  text-align: center;
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  z-index: 500;
`

class ShopifyWizard extends Component {

  constructor (props) {
    super(props)
    this.state = {
      template: getTemplateByApp(props.app, props.user.testGroup),
      mode: DEFAULT_MODE
    }
    this.processShopifyBarTitle(props)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.app.slidesCnt !== nextProps.app.slidesCnt) {
      this.setState({template: getTemplateByApp(nextProps.app, nextProps.user.testGroup)})
    }
    if (this.props.location.sceneNum !== nextProps.location.sceneNum) {
      this.processShopifyBarTitle(nextProps)
      this.setState({textFieldFocused: -1})
    }
  }

  setActiveMenuIndex = (i) => {
    const { dispatch, location } = this.props
    dispatch(changeEditorScene(location.sceneNum, i))
  }

  switchSceneToPrev = (dec = 1) => {
    console.log('switch scene to prev, dec', dec)
    const { dispatch, location } = this.props
    if (location.sceneNum >= dec) {
      dispatch(changeEditorScene(location.sceneNum - dec))
    }
  }

  switchSceneToNext = (customSceneNum = null) => {
    const { dispatch, location } = this.props
    const { template } = this.state
    const wizardConf = template.shopifyWizardConf
    if (customSceneNum && customSceneNum < wizardConf.length) {
      dispatch(changeEditorScene(customSceneNum))
    } else if (location.sceneNum < wizardConf.length - 1) {
      dispatch(changeEditorScene(location.sceneNum + 1))
    }
  }

  goNext = () => {
    // console.log('goNext')
    const { location } = this.props
    const { template } = this.state
    const activeMenuIndex = location.activeMenuIndex
    const wizardConf = template.shopifyWizardConf
    const sceneConf = wizardConf[location.sceneNum]
    if (sceneConf.menu && sceneConf.menu.length > activeMenuIndex + 1) {
      this.setActiveMenuIndex(activeMenuIndex + 1)
    } else {
      this.switchSceneToNext()
    }
  }

  getNextFieldTitle = () => {
    const { location } = this.props
    const { template } = this.state
    const activeMenuIndex = location.activeMenuIndex
    if (activeMenuIndex >= 0) {
      const wizardConf = template.shopifyWizardConf
      const sceneConf = wizardConf[location.sceneNum]
      // console.log('getNextFieldTitle, sceneConf', sceneConf, 'activeMenuIndex', activeMenuIndex, 'location.sceneNum', location.sceneNum)
      if (sceneConf && sceneConf.menu && sceneConf.menu.length > activeMenuIndex + 1) {
        const nextField = sceneConf.menu[activeMenuIndex + 1]
        return nextField.title
      }
    }
  }

  goBack = () => {
    console.log('goBack')
    this.switchSceneToPrev()
  }

  compareScenes (iaScene, customFieldsScene) {
    if (isObject(customFieldsScene)) {
      for (const p in customFieldsScene) {
        if (iaScene[p] !== customFieldsScene[p]) return false
      }
      return true
    } else {
      return iaScene === customFieldsScene
    }
  }

  handleSceneChange = (v) => {
    console.log('handleSceneChange', v)
    const { dispatch, location } = this.props
    const { template } = this.state
    const customFieldsConf = template.shopifyWizardConf
    let sceneNum = null
    for (const i in customFieldsConf) {
      const cf = customFieldsConf[i]
      const equal = this.compareScenes(v, cf.location)
      // console.log('equal', equal, 'v', v, 'cf.location', cf.location)
      if (equal) {
        sceneNum = Number(i)
        break
      }
    }
    // console.log('sceneNum', sceneNum, 'current', location.sceneNum)
    if (sceneNum !== null && sceneNum !== location.sceneNum) {
      console.log('changeEditorScene', sceneNum)
      dispatch(changeEditorScene(sceneNum, 0, v))
    }
  }

  handleSceneChangeIA = (v) => {
    console.log('handleSceneChangeIA', v)
    this.handleSceneChange(v)
  }

  renderInstantApp (customizedSettings) {
    const { app, location, dispatch } = this.props
    const { template } = this.state
    // console.log('renderInstantApp, location', location.sceneNum)
    const _InstantApp = getTemplateInfo(template.id).instantApp
    // console.log('sceneNum', sceneNum, 'fieldNum', fieldNum, 'customFieldsConf', customFieldsConf)
    const wizardConf = template.shopifyWizardConf
    const scene = clone(wizardConf[location.sceneNum])
    // console.log('customizedSettings', customizedSettings)
    return (
      <_InstantApp
        // key='shopify_wizard_main_ia'
        appId={app.id}
        templateId={template.id}
        settings={customizedSettings}
        onChange={this.handleSceneChangeIA}
        location={scene.location}
        editMode
        dispatch={dispatch}
      />
    )
  }


  renderOverlay () {
    const { location, app } = this.props
    const { template, textFieldFocused } = this.state
    const wizardConf = template.shopifyWizardConf
    const field = wizardConf[location.sceneNum]
    const overlays = get(field, 'overlays', [])
    return (
      <OverlayContainer>
        {overlays.map((overlayInfo, idx) => {
          let visible = true
          if ((field.id === shopifyAppSceneId.BULLET_POINTS || field.id === shopifyAppSceneId.FINAL_SCENE_TEXT) && idx !== textFieldFocused) {
            visible = false
          }
          return (
            <ShopifyOverlay
              key={idx}
              id={'overlayContainer'}
              app={app}
              overlayInfo={overlayInfo}
              template={template}
              visible={visible}
              field={field}
            />
          )
        })}
      </OverlayContainer>
    )
  }

  startProductsSlideWizard = (idx = null) => {
    this.setState({
      mode: PRODUCTS_SLIDE_WIZARD,
      editShowcaseIdx: idx
    })
  }

  startAddCollection = (idx = null) => {
    console.log('startAddCollection', idx)
    if (!isNil(idx)) {
      this.handleSceneChange({
        scene: scenes.SHOWCASE,
        showcaseNum: idx,
        shareButtonsVisible: 0,
        productShown: null
      })
    }
    this.setState({
      mode: ADD_COLLECTION,
      editShowcaseIdx: idx
    })
  }

  stopProductsSlideWizard = (isBack = false, toDesign = false) => {
    if (isBack) {
      this.setState({mode: DEFAULT_MODE})
    } else {
      const { app } = this.props
      const { editShowcaseIdx } = this.state
      let toShowcaseNum = editShowcaseIdx
      if (isNil(toShowcaseNum)) toShowcaseNum = app.slidesCnt
      if (toShowcaseNum && toShowcaseNum >= 0) {
        this.handleSceneChange({
          scene: scenes.SHOWCASE,
          showcaseNum: toShowcaseNum,
          shareButtonsVisible: 0,
          productShown: null
        })
      }
      this.setState({mode: DEFAULT_MODE})
    }
  }

  stopAddCollection = (isBack = false, toNextStep = false) => {
    if (isBack) {
      this.setState({mode: DEFAULT_MODE})
    } else {
      const { app } = this.props
      const { editShowcaseIdx } = this.state
      let toShowcaseNum = editShowcaseIdx
      if (isNil(toShowcaseNum)) toShowcaseNum = app.slidesCnt
      if (toNextStep) {
        console.log('->>> Design button pressed, switchSceneToNext')
        this.switchSceneToNext()
      }
      this.setState({mode: DEFAULT_MODE}, () => {
        // if (toShowcaseNum && toShowcaseNum >= 0) {
        //   this.handleSceneChange({
        //     scene: scenes.SHOWCASE,
        //     showcaseNum: toShowcaseNum,
        //     shareButtonsVisible: 0,
        //     productShown: null
        //   })
        // }
        // console.log('toDesign', toDesign)

      })
      // this.setState({mode: DEFAULT_MODE})
    }
  }

  onIAButtonClick = (iaButton) => {
    const { dispatch, location } = this.props
    console.log('onIAButtonClick', iaButton)
    dispatch(changeEditorScene(location.sceneNum + iaButton.sceneInc))
  }

  renderIAEditorLayer () {
    const { location, app } = this.props
    const { template } = this.state
    const wizardConf = template.shopifyWizardConf
    const field = wizardConf[location.sceneNum]
    return (
      <ShopifyIAEditorLayer
        app={app}
        field={field}
        startProductsSlideWizard={this.startProductsSlideWizard}
        onIAButtonClick={this.onIAButtonClick}
      />
    )
  }

  processShopifyBarTitle (props) {
    const { field } = props
    const shopifyBarTitle = get(field, 'shopifyBarTitle')
    if (shopifyBarTitle) setShopifyBarTitle(shopifyBarTitle)
  }

  onTextFieldFocus = (i) => {
    this.setState({
      textFieldFocused: i
    })
  }

  goLive = () => {
    console.log('goLive')
    this.trackEditorEvent('publish live') // eslint-disable-line no-undef
    const { app, dispatch } = this.props
    dispatch(publishAndActivate(app.id))
    gotoDashboard()
  }

  trackEditorEvent (event) {
    trackEvent('Editor: ' + event)
  }

  render () {
    const { app, location } = this.props
    const { template, mode, editShowcaseIdx } = this.state
    const wizardConf = template.shopifyWizardConf
    const field = wizardConf[location.sceneNum]
    const settings = template.settings
    let customizedSettings = settings
    if (has(app, 'customFields')) {
      customizedSettings = applyCustomFields(app.customFields, settings)
    }
    this.trackEditorEvent(field.id)
    if (mode === PRODUCTS_SLIDE_WIZARD) {
      return (
        <ProductsSlideWizard
          app={app}
          idx={editShowcaseIdx}
          stopProductsSlideWizard={this.stopProductsSlideWizard}
          customizedSettings={customizedSettings}
        />
      )
    } else if (mode === ADD_COLLECTION) {
      return (
        <AddCollection
          app={app}
          editShowcaseIdx={editShowcaseIdx}
          stopAddCollection={this.stopAddCollection}
          customizedSettings={customizedSettings}
        />
      )
    } else if (field.id === shopifyAppSceneId.INTRO_ILLUSTRATION) {
      return (
        <ShopifyWizardIllustration
          customizedSettings={customizedSettings}
          onClick={() => this.switchSceneToNext()}
          app={app}
          location={location}
        />
      )
    } else if (field.id === shopifyAppSceneId.FINAL_PREVIEW) {
      return (
        <ShopifyWizardFinalScene
          customizedSettings={customizedSettings}
          app={app}
          location={location}
          onBack={() => this.switchSceneToPrev(3)}
          goLive={this.goLive}
        />
      )
    } else {
      return (
        <Wrapper>
          <PhoneContainer>
            <CenteredLayer>
              <Phone needOffset={false}>
                {this.renderInstantApp(customizedSettings)}
                {this.renderOverlay()}
                {this.renderIAEditorLayer()}
              </Phone>
            </CenteredLayer>
          </PhoneContainer>
          <EditorContainer>
            <ShopifyAppEditor
              app={app}
              field={field}
              goNext={this.goNext}
              switchSceneToNext={this.switchSceneToNext}
              goBack={this.goBack}
              customizedSettings={customizedSettings}
              nextFieldTitle={this.getNextFieldTitle()}
              template={template}
              handleSceneChange={this.handleSceneChange}
              startProductsSlideWizard={this.startProductsSlideWizard}
              onTextFieldFocus={this.onTextFieldFocus}
              startAddCollection={this.startAddCollection}
              editShowcaseIdx={editShowcaseIdx}
            />
          </EditorContainer>
        </Wrapper>
      )
    }
  }
}

ShopifyWizard.propTypes = {
  app: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  location: state.location,
  user: state.user
})

export default connect(mapStateToProps)(ShopifyWizard)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/ShopifyWizard.js